import { render, staticRenderFns } from "./TabletReportsSection.vue?vue&type=template&id=b03d46c0&scoped=true"
import script from "./TabletReportsSection.vue?vue&type=script&lang=js"
export * from "./TabletReportsSection.vue?vue&type=script&lang=js"
import style0 from "./TabletReportsSection.vue?vue&type=style&index=0&id=b03d46c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d46c0",
  null
  
)

export default component.exports